const setViewportHeightVar = () => {
    document.body.style.setProperty('--svh', `${window.innerHeight / 100}px`);
};

export const initViewPortHeightVar = () => {
    setViewportHeightVar();

    window.addEventListener('resize', setViewportHeightVar);
};
